export const REPORT_TYPES_DISPLAY = {
    'essential_natal': 'essential_natal',
    'complete_soul': 'complete_soul',
    'ultimate': 'ultimate',
    'single_date_transit': 'single_date_transit',
    'three_month_transit': 'three_month_transit',
};

export default REPORT_TYPES_DISPLAY;